<app-box-explorer *ngIf="isAuthenticated; else BoxAuthBlock" [accessToken]="accessToken" (authenticationFailed)="validateAuthentication($event)"></app-box-explorer>
<ng-template #BoxAuthBlock>
    <div class="box-auth-loading" [ngClass]="{ 'background-jdai': otherGroup, 'background-all': allGroup, 'background-ftla': ftlaGroup }">
        <div *ngIf="!boxAuthLoadingError">Loading...</div>
        <div *ngIf="boxAuthLoadingError">Error Connecting Box. <a (click)="validateAuthentication(true)">Retry</a></div>
    </div>
</ng-template>
